module.exports = __webpack_public_path__ + "img/5-bn.807f9179.png";